<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_terms.png')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2026年10月1日
        </h2>

        <h3 class="terms-title">
          1. 本規約への同意
        </h3>
        <p>
          TIGER CASINOをご利用いただくお客様は、本利用規約および本規約内で参照される各種ポリシーに同意したものとみなされます。本規約は、TIGER CASINOとお客様との間のサービス利用に関する基本条件を定めるものです。内容をご確認いただき、同意いただけない場合は、アカウント登録またはサービス利用をお控えください。
        </p>

        <h3 class="terms-title">
          2. 運営情報
        </h3>
        <p>
          TIGER CASINOは、適用される法令、規制条件に基づき運営されます。
        </p>
        <ul class="terms-list">
          <li>運営会社：Aurex Global Holdings Ltd</li>
          <li>登録住所：Suite 5, Arch. Makariou III Avenue 155, Limassol 3026, Cyprus</li>
          <li>サポート窓口：[support@tiger-casinos.com]</li>
        </ul>

        <h3 class="terms-title">
          3. 登録資格
        </h3>
        <p>
          3.1 お客様は、アカウント登録時点で以下を表明し、保証するものとします。
        </p>
        <ul class="terms-list">
          <li>ご自身の名義でアカウントを作成すること。</li>
          <li>登録情報、ログイン情報、パスワードその他のアカウント情報を自己責任で管理すること。</li>
          <li>満20歳以上、かつ居住地・アクセス地域における法定ギャンブル年齢以上 であること。</li>
          <li>法令上オンラインカジノの利用が禁止されている国または地域からアクセスしないこと。</li>
          <li>自己の娯楽目的でのみサービスを利用し、第三者の代理として利用しないこと。</li>
        </ul>
        <p>
          3.2 20歳未満の利用、虚偽情報による登録、第三者名義での登録、または制限地域からの利用が確認された場合、TIGER CASINOはアカウントの停止、閉鎖、ベットの取消し、残高の保留または没収等の措置を行うことがあります。
        </p>

        <h3 class="terms-title">
          4. 規約変更
        </h3>
        <p>
          TIGER CASINOは、法令、規制、サービス内容、決済条件、ゲーム提供条件等の変更に応じて、本規約を随時改定することがあります。重要な変更がある場合は、サイト上の告知またはその他の方法により通知します。変更後もサービスを利用した場合、お客様は改定後の規約に同意したものとみなされます。
        </p>

        <h3 class="terms-title">
          5. アカウント管理
        </h3>
        <p>
          5.1 お客様は、正確かつ最新の登録情報を提供する必要があります。氏名、住所、生年月日、電話番号、メールアドレス、支払情報等に変更が生じた場合は、速やかに更新してください。
        </p>
        <p>
          5.2 TIGER CASINOでは、原則としてお一人様につき1アカウントのみ登録できます。同一人物、同一世帯、同一IP、同一端末、または関連性が疑われる複数アカウントが確認された場合、当社の判断により一部または全部のアカウントを停止・閉鎖し、関連するベット、ボーナス、賞金を無効とする場合があります。
        </p>
        <p>
          5.3 ログイン情報の管理責任はお客様にあります。第三者により不正利用された疑いがある場合は、直ちにサポートへご連絡ください。
        </p>

        <h3 class="terms-title">
          6. 本人確認・AML対応
        </h3>
        <p>
          6.1 TIGER CASINOは、本人確認、年齢確認、住所確認、支払方法の所有者確認、資金源確認、AMLおよび不正防止の目的で、必要に応じて追加書類の提出を求めることがあります。提出を拒否した場合、または確認が完了しない場合、アカウントの一時停止、出金保留、ベット取消し、残高保留等の措置を行うことがあります。
        </p>
        <p>
          6.2 不審な取引、マネーロンダリング、テロ資金供与、詐欺、共謀、またはその他の違法行為が疑われる場合、TIGER CASINOは関係当局または規制機関へ報告し、必要な措置を講じることがあります。
        </p>

        <h3 class="terms-title">
          7. 制限地域
        </h3>
        <p>
          7.1 お客様は、居住国またはアクセス地域の法令に従い、自己責任でサービスを利用するものとします。TIGER CASINOは、法令または社内方針により制限された地域からの利用を禁止します。
        </p>
        <p>
          7.2 VPN、プロキシ、位置情報偽装、端末情報の改変その他の方法により、実際の所在地を隠してサービスへアクセスすることは禁止されます。違反が確認された場合、アカウントの閉鎖、ベットの無効化、賞金または残高の没収等の対象となります。
        </p>

        <h3 class="terms-title">
          8. 入金・出金
        </h3>
        <p>
          8.1 入出金は、お客様ご本人名義の正当な決済手段のみ利用できます。第三者名義のウォレット、または不正に取得された支払手段の利用は禁止されます。
        </p>
        <p>
          8.2 最低出金額は6,000円となります。出金を行うには、最低入金条件、賭け条件、決済方法に関する確認、その他当社が定める要件を満たす必要があります。入金額に対して一定倍率のベットが必要となる場合があります。条件を満たさない出金申請については、当社の判断により保留、取消し、追加確認の対象となることがあります。
        </p>
        <p>
          8.3 原則入金には入金額の1倍分の賭け条件が付帯します。
        </p>
        <p>
          8.4 入金された資金については、AMLおよび不正防止の観点から、出金前に一定のプレイ条件を求める場合があります
        </p>
        <p>
          8.5 ボーナスまたはプロモーションにより付与された残高については、当該ボーナスに設定された賭け条件その他の条件を満たした後、出金可能な残高へ移行する必要があります。
        </p>
        <p>
          8.6 賭け条件を達成したボーナス残高は、BONUSウォレットからメインウォレットまたは対応する仮想通貨ウォレット等の出金可能なウォレットへ振り替えた後、お客様ご自身で出金申請を行う必要があります。
        </p>
        <p>
          8.7 ウォレット間の振替方法、対象ウォレット、換算方法その他ボーナス残高の取扱いについては、プロモーション一般利用規約および各プロモーション条件に従うものとします。
        </p>
        <p>
          8.8 出金は、原則として入金時に使用した決済方法と同一の方法で処理されます。ただし、当社が認める場合、または当該方法での処理が困難な場合は、別の方法を指定することがあります。外部金融機関、決済会社、ブロックチェーンネットワーク等に起因する遅延や手数料について、当社は責任を負いません。
        </p>
        <p>
          8.9 誤入金、過剰付与、誤ったボーナス付与、システムエラー等により残高が付与された場合、お客様は速やかにTIGER CASINOへ通知し、当該金額を使用しないものとします。誤付与された資金を用いたベットや出金は無効となる場合があります。
        </p>

        <h3 class="terms-title">
          9. ボーナス・プロモーション
        </h3>
        <p>
          9.1 TIGER CASINOは、キャンペーン、ボーナス、フリースピン、キャッシュバックその他のプロモーションを提供することがあります。各プロモーションには、個別の利用条件、賭け条件、有効期限、対象ゲーム、出金上限、禁止行為が適用されます。
        </p>
        <p>
          9.2 プロモーションへ参加した時点で、お客様は当該プロモーション条件に同意したものとみなされます。ボーナスの乱用、不正取得、複数アカウント利用、オポジットベット（ルーレット：赤黒を同時にベットする、バカラ：プレイヤーとバンカーを同時にベットする）、ローリスクベット（ルーレットで25個以上の数字（25個を含む）・ミニルーレットで8個以上の数字（8個を含む）をカバーするスプレッド．コンビネーションなどのリスクヘッジベットすること。）、システムの抜け道を利用したプレイ等が確認された場合、当社はボーナス、勝利金、残高を無効または没収し、アカウントを停止・閉鎖する権利を有します。
        </p>

        <h3 class="terms-title">
          10. 禁止行為
        </h3>
        <p>
          10.1 以下の行為は禁止されます。
        </p>
        <ul class="terms-list">
          <li>不正アクセス、ハッキング、コード改変、脆弱性の悪用。</li>
          <li>ボット、自動化ツール、外部支援ツール、機械的または電子的な不正手段の利用。</li>
          <li>複数アカウント、第三者との共謀、相反ベット等による不正な利益獲得。</li>
          <li>暗号資産ウォレット等の不正利用。</li>
          <li>プロモーション条件、賭け条件、ゲーム仕様の悪用。</li>
          <li>他のお客様、TIGER CASINO、従業員、委託先、ゲームプロバイダーに対する誹謗中傷、脅迫、侮辱、迷惑行為。</li>
          <li>法令、規制、本規約、個別ルールに違反する行為。</li>
        </ul>
        <p>
          10.2 TIGER CASINOは、違反が疑われる場合、調査完了までアカウント機能、出金申請、残高、ボーナスを一時的に制限できます。
        </p>

        <h3 class="terms-title">
          11. サービス提供・ゲームエラー
        </h3>
        <p>
          11.1 ゲームラウンド、ベット、残高、入出金、プロモーション等にシステムエラー、通信障害、第三者事業者の障害、表示ミス、計算ミスが発生した場合、TIGER CASINOは該当取引を取消し、修正し、または再処理する権利を有します。
        </p>
        <p>
          11.2 ゲームが中断した場合、可能な範囲で未完了ラウンドを再開します。再開が困難な場合は、当社の判断により当該ラウンドを取消し、賭け金を返金することがあります。
        </p>
        <p>
          11.3 TIGER CASINOは、サービスが常に中断なく利用できること、または完全にエラーがないことを保証しません。
        </p>

        <h3 class="terms-title">
          12. 知的財産権
        </h3>
        <p>
          12.1 サイト、ソフトウェア、ゲーム、データ、ロゴ、商標、デザイン、コンテンツ、システム、データベース等に関する知的財産権は、TIGER CASINOまたは正当な権利者に帰属します。お客様は、許可なく複製、改変、配布、販売、貸与、リバースエンジニアリング、逆コンパイル、逆アセンブル、ソースコード取得その他の権利侵害行為を行ってはなりません。
        </p>
        <p>
          12.2 お客様が使用するニックネーム、プロフィール画像、投稿内容等について、TIGER CASINOはサービス運営、本人確認、不正防止、プロモーション、サポート対応の目的で利用できるものとします。
        </p>

        <h3 class="terms-title">
          13. お問い合わせ・アカウント閉鎖
        </h3>
        <p>
          13.1 サービス、支払い、アカウント、ボーナス、ゲーム結果等に関するお問い合わせは、問題発生後速やかにサポート窓口へご連絡ください。ゲーム結果に関するお問い合わせは、発生後7営業日以内とします。その他のお問い合わせは、発生後1か月以内を目安とします。
        </p>
        <p>
          13.2 ゲームエラー、予期しない残高の消失、取引異常等についてお問い合わせいただく場合は、調査のため以下の情報をご提供ください。
        </p>
        <ul class="terms-list">
          <li>発生日時</li>
          <li>トランザクションIDまたは取引番号</li>
          <li>対象ゲーム、ゲームラウンド、ベットID等</li>
          <li>アカウントIDまたは登録情報</li>
          <li>エラー画面や履歴画面のスクリーンショット</li>
          <li>利用端末、ブラウザ、通信環境</li>
        </ul>
        <p>
          13.3 お客様は、サポートへ連絡することでアカウント閉鎖を申請できます。未決済ベット、未完了の本人確認、マイナス残高、調査中の取引、未達成の条件がある場合、閉鎖または出金処理が保留されることがあります。
        </p>

        <h3 class="terms-title">
          14. 休眠アカウント
        </h3>
        <p>
          一定期間ログイン、入出金、ベット等の活動がないアカウントは、休眠アカウントとして扱われる場合があります。休眠アカウントに管理手数料を設定する場合は、金額、開始時期、通知方法、再開方法を別途明示します。
        </p>

        <h3 class="terms-title">
          15. 暗号資産取引
        </h3>
        <p>
          15.1 暗号資産で入出金を行う場合、お客様は指定された通貨、ネットワーク、ウォレットアドレスを十分確認する必要があります。誤った通貨、ネットワーク、アドレスへの送金は回収できない場合があり、TIGER CASINOはこれに起因する損失について責任を負いません。
        </p>
        <p>
          15.2 暗号資産取引については、追加のKYC、セキュリティ審査、資金源確認、デューデリジェンスを求める場合があります。指定期限内に確認が完了しない場合、出金保留またはアカウント制限の対象となることがあります。
        </p>

        <h3 class="terms-title">
          16. 準拠法・責任制限
        </h3>
        <p>
          16.1 本規約は、準拠法国・地域の法令に準拠し、これに従って解釈されるものとします。本サービスまたは本規約に関連して生じる紛争については、管轄裁判所を第一審の専属的合意管轄裁判所とします。ただし、適用される法令または規制により別途定めがある場合は、その定めに従うものとします。
        </p>
        <p>
          16.2 法令で認められる最大限の範囲において、TIGER CASINOは、通信回線またはインターネット環境の障害、お客様の端末または利用環境、第三者決済事業者、金融機関、ブロックチェーンネットワーク、ゲームプロバイダーその他第三者サービスに起因する障害、遅延、損失その他の損害について責任を負わないものとします。
        </p>
        <p>
          16.3 また、お客様による本規約への違反、禁止行為、不正利用、または適用される法令への違反に起因して生じた損害について、TIGER CASINOは責任を負いません。
        </p>
        <p>
          16.4 ただし、TIGER CASINOの故意または重大な過失により生じた損害、その他適用される法令上免責することが認められない責任については、この限りではありません。
        </p>
        <p>
          16.5 お客様による不正行為、本規約への重大な違反、またはTIGER CASINOもしくは第三者に損害を与える行為が確認された場合、TIGER CASINOは、適用される法令および本規約に基づき、アカウントの制限その他必要な措置を講じるとともに、必要に応じて法的措置を講じる権利を有します。
        </p>
        <p>
          16.6 法令で認められる最大限の範囲において、TIGER CASINOは、サービス利用、通信障害、第三者決済、ゲームプロバイダー、端末環境、法令違反、不正利用、規約違反に起因する損害について責任を負いません。ただし、当社が適切と判断する場合、お客様に対して法的措置を講じる権利を留保します。
        </p>
      </div>
    <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'TermsTiger',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
/* 段落標題：與上一段拉開距離、貼近自己的內容 */
.terms-title {
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
}

/* 第一個標題不需要上方間距 */
.update-time + .terms-title {
  margin-top: 0;
}

/* 段落與標題、清單之間的間距收斂 */
.content p {
  margin: 0 0 1rem;
}

.terms-list {
  margin: 0.5rem 0 1rem 1.5rem;
}

/* 黑底上的項目符號改為白色 */
ul.terms-list,
ol.terms-list {
  list-style-position: outside;
  padding-left: 1.4rem;
}

ul.terms-list {
  list-style: disc;
}

ol.terms-list {
  list-style: decimal;
}

.terms-list li::marker {
  color: #fff;
}
</style>
